import { render } from "./AppLoader.vue?vue&type=template&id=4caf673e&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=4caf673e&scoped=true&lang=css"

import exportComponent from "/home/check/checkout.trguj.me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caf673e"]])

export default __exports__